import { FC } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";
import { Image } from "@/icons/outlined";

interface IdleThumbnailProps {
  url: string | null;
}

export const IDLE_THUMBNAIL_SIZE = 48;

export const IdleThumbnail: FC<IdleThumbnailProps> = ({ url }) => {
  const optimizedUrl = url ? withCloudinaryAutoFormat(url) : null;

  return (
    <Box
      sx={(theme) => ({
        width: IDLE_THUMBNAIL_SIZE,
        height: IDLE_THUMBNAIL_SIZE,
        flexShrink: 0,
        borderRadius: theme.radius(0.5),
        border: `1px solid ${theme.palette.border.neutral.quiet}`,
        overflow: "hidden",
        backgroundColor: theme.palette.surface.neutral.quiet,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      })}
    >
      {optimizedUrl ? (
        <Box component="img" src={optimizedUrl} alt="" sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={(theme) => ({ color: theme.palette.text.neutral.quiet, width: "100%", height: "100%" })}
        >
          <DashboardTypography variant="body2">
            <Image fontSize="inherit" />
          </DashboardTypography>
        </Stack>
      )}
    </Box>
  );
};

const withCloudinaryAutoFormat = (url: string): string => {
  if (!url.includes("res.cloudinary.com") || !url.includes("/upload/")) {
    return url;
  }
  if (url.includes("/upload/f_auto") || url.includes(",f_auto")) {
    return url;
  }
  return url.replace("/upload/", "/upload/f_auto,q_auto/");
};
